import React from 'react';
import LabelsGridActions from './LabelsGridActions';

const LabelsGridColumns = [
    {
        id: 'id',
        Header: 'Id',
        accessor: 'id',
        width: 70,
    },
    {
        Header: 'Label name',
        accessor: 'display_name',
        sortable: false,
    },
    {
        Header: 'Type',
        accessor: 'label_type_name',
        sortable: false,
    },
    {
        Header: 'Actions',
        width: 150,
        sortable: false,
        Cell: (props) => <LabelsGridActions rowProps={props} />,
    },
];

export default LabelsGridColumns;



// WEBPACK FOOTER //
// ./src/containers/labels/LabelsGridColumns.jsx